import { ISearchFields } from 'types/searchFields';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ISearchResp } from '@api/responseModels/search/searchResponse';
import { applySearchRanking } from '@utils/searchRanking';

export class SearchGroup extends CRMAPIBase {
    /** Все поиски идут здесь — порядок выдачи задаёт `applySearchRanking` */
    async search(searchFields: ISearchFields): Promise<RequestResult<ISearchResp>> {
        const result = await this.post<null>('/search', applySearchRanking(searchFields));
        return result;
    }
}
